import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './language-select.component.html';
var LanguageSelectComponent = (function () {
    function LanguageSelectComponent() {
        this.expanded = false;
    }
    LanguageSelectComponent.prototype.ngOnInit = function () {
        var random = String(Math.random());
        this.inputId = "input__" + random.slice(random.indexOf('.') + 1);
    };
    LanguageSelectComponent.prototype.selectLanguage = function (language) {
        if (!this.ngModel) {
            return;
        }
        this.expanded = false;
        if (this.ngModel.$viewValue === language) {
            return;
        }
        this.ngModel.$setViewValue(language);
    };
    LanguageSelectComponent.prototype.disabled = function () {
        return (this.languages || []).length < 2;
    };
    LanguageSelectComponent.prototype.getFlagCode = function (language) {
        var languageCode = language.languageCode, marketLocales = language.marketLocales;
        var marketLocale = languageCode || (marketLocales || [])[0];
        if (!marketLocale) {
            return undefined;
        }
        var flagCode = ((marketLocale || '').split('-')[1] || '').toLowerCase();
        return flagCode;
    };
    LanguageSelectComponent.prototype.getLabelCssClass = function (language) {
        var numberCssClass = (this.languages || []).length > 1 ? 'multiple' : 'single';
        return numberCssClass + " " + this.getFlagCode(language);
    };
    LanguageSelectComponent.prototype.getLabelText = function (language) {
        var languageTitle = language.languageTitle, languageTitleEn = language.languageTitleEn, languageTitleLocal = language.languageTitleLocal;
        var labelText = '';
        if (this.showLocalLanguage && languageTitleEn !== languageTitleLocal) {
            labelText = languageTitleEn + " / " + languageTitleLocal;
        }
        else if (this.showLocalLanguage) {
            labelText = languageTitleEn;
        }
        else {
            labelText = languageTitle;
        }
        return labelText;
    };
    LanguageSelectComponent.prototype.localeSensitiveComparator = function (x1, x2) {
        if (x1.type !== 'string' || x2.type !== 'string') {
            return x1.index < x2.index ? -1 : 1;
        }
        return x1.value.localeCompare(x2.value);
    };
    LanguageSelectComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], LanguageSelectComponent.prototype, "languages", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], LanguageSelectComponent.prototype, "selectLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], LanguageSelectComponent.prototype, "showLocalLanguage", void 0);
    LanguageSelectComponent = __decorate([
        Component({
            require: {
                ngModel: '^ngModel',
            },
            selector: 'languageSelect',
            template: template,
        })
    ], LanguageSelectComponent);
    return LanguageSelectComponent;
}());
export { LanguageSelectComponent };
